const ListingETLNew = function (flatData, listingConfigToListingCollectionsMap, listingCollectionComponentToListingCollectionMap) {

    // Cache for parent lookups to avoid repeated traversal
    const m2KeyToParentM1Keys = {};
    const getParentM1Keys = function (fd, childM2Key) {
        if (m2KeyToParentM1Keys[childM2Key]) return m2KeyToParentM1Keys[childM2Key];
        let parentM1Keys = [];
        for (let [m1Key, m1Data] of Object.entries(fd)) {
            if (childM2Key in m1Data) {
                parentM1Keys.push(m1Key);
            }
        }
        m2KeyToParentM1Keys[childM2Key] = parentM1Keys;
        return parentM1Keys;
    };

    const makeMaps = function () {
        const listingCollectionToSystemsMap = {};
        const componentToContentGroupMap = {};
        const systemMap = {};
        const listingM1Keys = [];
        const listingToSystemsMap = {};
        const listingToTierMap = {};
        const listingToParentListingsMap = {};
        const listingCollectionToListingConfigTierMap = {};
        const listingConfigToListingsColumnsMap = {};
        const listingConfigToListingsMap = {};
        const listingToListingCollectionsMap = {};
        const listingToListingConfigMap = {};
        const listingCollectionToParentComponentMap = {};

        const fd = flatData;

        // Precompute system keys for fast lookup
        const systemKeys = Object.keys(fd).filter(k => k.startsWith('system.'));

        for (let [m1Key, m1Data] of Object.entries(fd)) {
            if (m1Key.startsWith('system.')) {
                systemMap[m1Key] = { name: m1Data.display_name };
            }

            if (m1Key.startsWith('listing.')) {
                listingM1Keys.push(m1Key);

                for (let m2Key of Object.keys(m1Data)) {
                    if (m2Key.startsWith('listing.')) {
                        if (!listingToParentListingsMap[m2Key]) {
                            listingToParentListingsMap[m2Key] = [];
                        }

                        // Avoid duplicates
                        if (!listingToParentListingsMap[m2Key].includes(m1Key)) {
                            listingToParentListingsMap[m2Key].push(m1Key);
                        }
                    }
                }
            }

            if (m1Key.startsWith('listing_collection.')) {
                if (!listingCollectionToListingConfigTierMap[m1Key]) {
                    listingCollectionToListingConfigTierMap[m1Key] = {};
                }

                for (let m2Key of Object.keys(m1Data)) {
                    if (m2Key.startsWith('listing_config.')) {
                        let m2Data = fd[m2Key];

                        // T1 listing_config
                        listingCollectionToListingConfigTierMap[m1Key][0] = m2Key;

                        if (!listingConfigToListingCollectionsMap[m2Key]) {
                            listingConfigToListingCollectionsMap[m2Key] = [];
                        }
                        listingConfigToListingCollectionsMap[m2Key].push(m1Key);

                        // T(n) listing_config
                        let i = 0;
                        let seenConfigs = new Set();
                        while (~Object.keys(m2Data).join('').indexOf('listing_config.')) {
                            i++;
                            let childListingConfigM1Key = Object.keys(m2Data).find((k) => k.startsWith('listing_config.'));
                            if (!childListingConfigM1Key || seenConfigs.has(childListingConfigM1Key)) break;
                            seenConfigs.add(childListingConfigM1Key);

                            m2Data = fd[childListingConfigM1Key];
                            listingCollectionToListingConfigTierMap[m1Key][i] = childListingConfigM1Key;

                            if (!listingConfigToListingCollectionsMap[childListingConfigM1Key]) {
                                listingConfigToListingCollectionsMap[childListingConfigM1Key] = [];
                            }
                            listingConfigToListingCollectionsMap[childListingConfigM1Key].push(m1Key);
                        }
                    }
                }
            }

            if (m1Key.startsWith('listing_config.')) {
                if (!listingConfigToListingsColumnsMap[m1Key]) {
                    listingConfigToListingsColumnsMap[m1Key] = {};
                }

                for (let [m2Key, m2Data] of Object.entries(m1Data)) {
                    if (m2Key.startsWith('listing_column.')) {
                        listingConfigToListingsColumnsMap[m1Key][m2Key] = m2Data;
                        listingConfigToListingsColumnsMap[m1Key][m2Key].name = fd[m2Key].display_name;

                        let listingColumnTypeM1Key = Object.keys(fd[m2Key]).filter((k) => {
                            return k.startsWith('listing_column_type.');
                        })[0];

                        listingConfigToListingsColumnsMap[m1Key][m2Key].type = fd[listingColumnTypeM1Key].type;
                        listingConfigToListingsColumnsMap[m1Key][m2Key].fieldType = fd[listingColumnTypeM1Key].display_name;
                    }
                }
            }

            if (m1Key.startsWith('component.')) {
                for (let m2Key of Object.keys(m1Data)) {
                    if (m2Key.startsWith('listing_collection.')) {
                        listingCollectionToParentComponentMap[m2Key] = m1Key;

                        // Optimize parent search
                        let parents = getParentM1Keys(fd, m1Key), skip = false;
                        let parentSet = new Set(parents);
                        while (![...parentSet].some(k => k.startsWith('system.'))) {
                            parents = getParentM1Keys(fd, parents[0]);

                            if (parents.length === 0) {
                                skip = true;
                                break;
                            }
                            parentSet = new Set(parents);
                        }

                        if (skip) {
                            continue;
                        }

                        let systemM1Keys = parents.filter((k) => k.startsWith('system.'));

                        if (!listingCollectionToSystemsMap[m2Key]) {
                            listingCollectionToSystemsMap[m2Key] = [];
                        }
                        for (let systemM1Key of systemM1Keys) {
                            if (!listingCollectionToSystemsMap[m2Key].includes(systemM1Key)) {
                                listingCollectionToSystemsMap[m2Key].push(systemM1Key);
                            }
                        }
                    }
                }
            }
        }

        for (let componentM1Key of Object.keys(listingCollectionToParentComponentMap)) {
            for (let bundle of (fd[componentM1Key]?._bundle || [])) {
                if (bundle.attr.type === 'custom_group') {
                    if (!componentToContentGroupMap[componentM1Key]) {
                        componentToContentGroupMap[componentM1Key] = [];
                    }
                    componentToContentGroupMap[componentM1Key].push(bundle);

                }
            }
        }

        // Resolve a listing's tier + listing_config from the listing_config.* key bronco
        // nests under the listing itself. Used when the parent walk dead-ends (an orphan
        // listing, or a child whose only reachable parents are orphans) — on
        // use_all_listings accounts bronco ships every listing in the config chain, so
        // orphans are expected and must not blank the component (DEV-12238).
        const resolveByOwnConfig = function (listingM1Key) {
            const ownConfigM1Key = Object.keys(fd[listingM1Key] || {}).find((k) => k.startsWith('listing_config.'));
            if (!ownConfigM1Key) return null;

            for (let [listingCollectionM1Key, tierMap] of Object.entries(listingCollectionToListingConfigTierMap)) {
                for (let [tier, listingConfigM1Key] of Object.entries(tierMap)) {
                    if (listingConfigM1Key === ownConfigM1Key) {
                        return { listingCollectionM1Key, listingConfigM1Key, tier: Number(tier) };
                    }
                }
            }

            return null;
        };

        for (let listingM1Key of listingM1Keys) {
            // Breadth-first walk up through ALL listing parents (not just parents[0]) until a
            // listing_collection.* is reached. The number of listing hops is the tier. A child
            // with one orphan parent and one linked parent still resolves via the linked one.
            let i = 0;
            let frontier = getParentM1Keys(fd, listingM1Key);
            let parents = frontier.filter((k) => k.startsWith('listing_collection.'));
            const visited = new Set([listingM1Key]);
            while (parents.length === 0) {
                const nextFrontier = [];
                for (let parentM1Key of frontier) {
                    if (!parentM1Key.startsWith('listing.') || visited.has(parentM1Key)) continue;
                    visited.add(parentM1Key);
                    for (let grandParentM1Key of getParentM1Keys(fd, parentM1Key)) {
                        if (!nextFrontier.includes(grandParentM1Key)) nextFrontier.push(grandParentM1Key);
                    }
                }

                if (nextFrontier.length === 0) {
                    break;
                }

                i++;
                frontier = nextFrontier;
                parents = frontier.filter((k) => k.startsWith('listing_collection.'));
            }

            if (parents.length === 0) {
                // Dead end: no path to a listing_collection. Fall back to the listing's own config.
                const own = resolveByOwnConfig(listingM1Key);
                if (!own) {
                    console.warn(`ListingETLNew: skipping ${listingM1Key} — no path to a listing_collection and no listing_config on the listing`);
                    continue;
                }

                listingToTierMap[listingM1Key] = own.tier;
                listingToListingCollectionsMap[listingM1Key] = [own.listingCollectionM1Key];
                listingToSystemsMap[listingM1Key] = [...(listingCollectionToSystemsMap[own.listingCollectionM1Key] || [])];
                listingToListingConfigMap[listingM1Key] = own.listingConfigM1Key;
                continue;
            }

            listingToTierMap[listingM1Key] = i;

            if (!listingToListingCollectionsMap[listingM1Key]) {
                listingToListingCollectionsMap[listingM1Key] = [];
            }

            if (!listingToSystemsMap[listingM1Key]) {
                listingToSystemsMap[listingM1Key] = [];
            }

            for (let parentM1Key of parents) {
                if (parentM1Key.startsWith('listing_collection.')) {
                    let listingCollectionM1Key = parentM1Key;
                    listingToListingCollectionsMap[listingM1Key].push(listingCollectionM1Key);

                    let systemM1Keys = listingCollectionToSystemsMap[listingCollectionM1Key] || [];
                    for (let systemM1Key of systemM1Keys) {
                        listingToSystemsMap[listingM1Key].push(systemM1Key);
                    }

                    let listingConfigM1Key = listingCollectionToListingConfigTierMap[listingCollectionM1Key][i];
                    listingToListingConfigMap[listingM1Key] = listingConfigM1Key;
                }
            }
        }

        for (let [listingM1Key, listingConfigM1Key] of Object.entries(listingToListingConfigMap)) {
            if (listingConfigM1Key === undefined) {
                continue;
            }

            if (!listingConfigToListingsMap[listingConfigM1Key]) {
                listingConfigToListingsMap[listingConfigM1Key] = {};
            }

            let listing = {
                vals: {},
                systems: listingToSystemsMap[listingM1Key],
                tier: listingToTierMap[listingM1Key],
            };
            if (listingToParentListingsMap[listingM1Key]) {
                listing.parent_listings = listingToParentListingsMap[listingM1Key];
            }

            let cols = listingConfigToListingsColumnsMap[listingConfigM1Key];
            listing.cols = cols;

            for (let [colM1Key, col] of Object.entries(cols)) {
                if (typeof fd?.[listingM1Key]?.[colM1Key] === 'undefined') {
                    listing.vals[col.name] = null;
                } else {
                    let type = col.type;

                    listing.vals[col.name] = fd[listingM1Key][colM1Key][type];
                }
            }

            let listingCollectionM1Keys = listingToListingCollectionsMap[listingM1Key];
            for (let listingCollectionM1Key of listingCollectionM1Keys) {
                let componentM1Key = listingCollectionToParentComponentMap[listingCollectionM1Key];

                if (typeof fd[componentM1Key]?._bundle !== 'undefined') {
                    if (!listing.content_groups) {
                        listing.content_groups = [];
                    }

                    listing.content_groups.push(componentM1Key);
                }
            }

            listingConfigToListingsMap[listingConfigM1Key][listingM1Key] = listing;
        }

        let listings = {
            systems: systemMap,
            content_groups: componentToContentGroupMap,
            listings: {},
            cols: {},
        };

        for (let listingConfigM1Key of Object.keys(listingConfigToListingsMap)) {
            listings.cols = { ...(listings.cols || {}), ...listingConfigToListingsColumnsMap[listingConfigM1Key] };
            listings.listings[listingConfigM1Key] = listingConfigToListingsMap[listingConfigM1Key];
        }

        return {
            listingToTierMap,
            listingToParentListingsMap,
            listingToListingConfigMap,
            listingCollectionToListingConfigTierMap,
        };
    };

    const makeRawCols = function (listingConfigM1Key) {
        let cols = {};
        for (let m2Key of Object.keys(flatData[listingConfigM1Key])) {
            if (m2Key.startsWith('listing_column.')) {
                cols[m2Key] = makeDefaultColumnValue(m2Key);
            }
        }

        return cols;
    };

    const makeDefaultColumnValue = function (listingColumnM1Key) {
        let columnType;
        for (let m2Key of Object.keys(flatData[listingColumnM1Key])) {
            if (m2Key.startsWith('listing_column_type.')) {
                columnType = flatData[m2Key].type;
                break;
            }
        }

        switch (columnType) {
            case 'string':
            case 'text':
                return '';

            case 'float':
            case 'int':
                return 0;

            case 'bool':
                return false;
        }

        return '';
    };

    const extractMessagingLabels = function () {
        const labels = [];
        // Cache parsed messaging options to avoid repeated parsing
        for (const m1Key in flatData) {
            if (m1Key.startsWith("account.")) {
                for (const m2Key in flatData[m1Key]) {
                    if (m2Key.startsWith("setting.")) {
                        const setting = flatData[m2Key];
                        if (setting.name === "messaging_options") {
                            let innerJson;
                            try {
                                innerJson = JSON.parse(flatData[m1Key][m2Key].json);
                            } catch {
                                continue;
                            }
                            if (innerJson?.messaging?.options) {
                                for (const option of innerJson.messaging.options) {
                                    labels.push(option.label);
                                }
                            }
                        }
                    }
                }
            }
        }
        return labels;
    }

    const getM2Data = function (tree, m1KeyPrefix, m2KeyPrefix, opts = {}) {
        const data = {};
        for (let [m1Key, m1Data] of Object.entries(tree)) {
            if (m1Key.startsWith(m1KeyPrefix)) {
                for (let [m2Key, m2Data] of Object.entries(m1Data)) {
                    if (m2Key.startsWith(m2KeyPrefix)) {
                        let m2Tree = tree[m2Key];
                        let groupKey = m2Tree[opts.groupKey] || m2Key;

                        if (!data[groupKey]) {
                            data[groupKey] = {};
                        }

                        data[groupKey][m1Key] = opts.m1Keys || {};
                    }
                }
            }
        }

        return data;
    }

    const getComponentSettings = function (m1Key) {
        let m1Data = flatData[m1Key];

        let settings = {};
        for (let [m2Key, m2Data] of Object.entries(m1Data)) {
            if (m2Key.startsWith('setting.')) {
                let setting = flatData[m2Key];
                for (let key of Object.keys(setting)) {
                    if (key.startsWith('setting_type.')) {
                        let settingType = flatData[key].type;
                        let settingValue = m2Data[settingType] || null;
                        try {
                            if (settingType === 'json') {
                                settingValue = JSON.parse(m2Data[settingType]);
                            }
                        } catch (err) { }

                        settings[setting.name] = {
                            type: settingType,
                            value: settingValue,
                        };

                        break;
                    }
                }
            }
        }

        return settings;
    }

    const dataType = function (listingColumn) {
        for (let [key, data] of Object.entries(listingColumn)) {
            if (key.startsWith('listing_column_type.')) {
                return flatData[key].display_name;
            }
        }
    }

    // Returns null (after a console.warn) when the listing cannot be resolved to a
    // listing_config / tier, so one bad listing never throws and blanks the whole
    // component (DEV-12238). Callers must skip a null result.
    const getListing = function (m1Key, listingGroup, listingGroupM1Key, listingConfigTierlist) {
        let listings = [];
        let detailsGrp = [];

        let listingListingConfigM1Key = listingToListingConfigMap[m1Key];
        let listingTier = listingToTierMap[m1Key];
        if (!flatData[m1Key] || !listingListingConfigM1Key || !flatData[listingListingConfigM1Key]
            || typeof listingTier === 'undefined' || !flatData[listingConfigTierlist?.[listingTier]]) {
            console.warn(`ListingETLNew: dropping ${m1Key} — unresolved listing_config/tier (orphan parent?)`);
            return null;
        }

        let rawCols = makeRawCols(listingListingConfigM1Key);
        for (let [m2Key, m2Data] of Object.entries(flatData[m1Key])) {
            if (m2Key.startsWith('listing.')) {
                let listing = getListing(m2Key, listingGroup, listingGroupM1Key, listingConfigTierlist);
                if (!listing) {
                    continue;
                }
                listing.m1Key = m2Key;
                listing.settings = getComponentSettings(listing.m1Key);

                listings.push(listing);
            }

            if (m2Key.startsWith('listing_column.')) {
                let keys = Object.keys(m2Data);
                rawCols[m2Key] = m2Data[keys[0]];

                let displayName = flatData[m2Key].display_name;
                let type = dataType(flatData[m2Key]);
                detailsGrp.push({
                    value: m2Data[keys[0]],
                    type: type,
                    label: displayName,
                    column_uuid: m2Key,
                });
            }
        }

        //get listing parents,
        let rootParent = false
        let parentM1Keys = [];
        let currentChildKey = m1Key
        while (!rootParent) {
            let parentKey = listingToParentListingsMap[currentChildKey] || ''
            if (!parentKey) {
                rootParent = true
                break;
            }

            parentKey = [...new Set(parentKey)];
            parentM1Keys.push(parentKey)
            currentChildKey = parentKey
        }
        //get parent cols		
        let parentCols = {}
        parentM1Keys.forEach(function (parentM1Key) {
            if (parentM1Key.length === 1) {
                for (let [m2Key, m2Data] of Object.entries(flatData[parentM1Key])) {

                    if (m2Key.startsWith('listing_column.')) {
                        let keys = Object.keys(m2Data);
                        parentCols[m2Key] = m2Data[keys[0]];
                    }

                }
            }
        });
        // merge parentCols in to RawCols
        rawCols = Object.assign({}, rawCols, parentCols)

        let colKeys = Object.keys(rawCols)
        let touchAction;
        let tierConfig;

        // get listing tier to listing config tier relation (listingTier resolved + guarded above)
        let listingConfigTier = listingConfigTierlist[listingTier]
        const listingTierName = flatData[listingConfigTier].display_name;

        for (let [m2Key, m2Data] of Object.entries(flatData[listingGroupM1Key])) {
            if (m2Key === listingConfigTier) {
                tierConfig = {
                    boxActiveLayout: m2Data.active_layout,
                    boxColumnsPerRow: m2Data.number_of_columns,
                    boxStyleDisplay: m2Data.boxstyle_display,
                    detailHeaders: m2Data.detail_headers,
                    iframeUrlLabel: m2Data.iframe_url_label,
                    listingPagination: m2Data.listing_pagination,
                    listingTier,
                    listingTierName,
                    labelSeperator: m2Data.label_seperator,
                    mobileButtonLabel: m2Data.mobile_button_label,
                    mobileButtonOrder: m2Data.mobile_button_order,
                    mobileClickEvent: m2Data.mobile_click_event,
                    mobileDialing: m2Data.mobile_dialing,
                    mobileDisplay: m2Data.mobile_display,
                    mobileWayfinding: m2Data.mobile_wayfinding,
                    paginationTimer: m2Data.pagination_timer,
                    showSubNavButton: m2Data.show_sub_nav_button,
                    touchAction: m2Data.touch_action,
                    videoUrlLabel: m2Data.video_url_label,
                }
                touchAction = m2Data.touch_action

                // Build additional search fields/values from the selected listing columns for this tier
                try {
                    const messagingLabels = extractMessagingLabels();
                    const normalizeValue = (val) => {
                        if (typeof val === 'string' && val.trim().startsWith('{')) {
                            try {
                                const parsed = JSON.parse(val);
                                if (parsed?.cc) {
                                    return messagingLabels.includes(parsed.label)
                                        ? `${parsed.label}-${parsed.area}-${parsed.n}`
                                        : `${parsed.area}-${parsed.n}`;
                                }
                                if (parsed?.email) {
                                    return messagingLabels.includes(parsed.label)
                                        ? `${parsed.label}-${parsed.email}@${parsed.domain}`
                                        : `${parsed.email}@${parsed.domain}`;
                                }
                            } catch (_) { /* noop */ }
                        }
                        if (val === 'undefined' || typeof val === 'undefined' || val === null) return '';
                        return String(val);
                    };

                    let addl = m2Data.additional_search_fields;
                    let selectedUUIDs = [];
                    if (Array.isArray(addl)) {
                        selectedUUIDs = addl;
                    } else if (typeof addl === 'string') {
                        selectedUUIDs = addl.split(',').map(s => s.trim()).filter(Boolean);
                    }

                    // Support both bare UUIDs and full m1Keys
                    const colKeys = selectedUUIDs.map(u => u.startsWith('listing_column.') ? u : `listing_column.${u}`);
                    const addlValues = colKeys
                        .map(k => normalizeValue(rawCols[k]))
                        .filter(v => v && v.length > 0);

                    tierConfig.additionalSearchFields = selectedUUIDs;
                    tierConfig.additionalSearchValues = addlValues;
                } catch (e) {
                    // Fail-safe: ensure fields exist even if parsing fails
                    tierConfig.additionalSearchFields = [];
                    tierConfig.additionalSearchValues = [];
                }
            }
        }
        // get only listing column groups associated with this listing tier.
        let tierToListingColumnGroupMap = [];

        for (let listingColumnGroup of listingGroup) {
            if (Object.keys(flatData[listingColumnGroup.m1Key]).includes(listingConfigTier)) {
                tierToListingColumnGroupMap.push(listingColumnGroup);
            }
        }

        // A column type flagged exclude_from_search_default (image/PDF URLs, QR codes, messaging
        // payloads…) is never searched, whatever its column ref says.
        const columnTypeExcludesSearch = (colM1Key) => {
            const columnData = flatData[colM1Key] || {};
            for (const key of Object.keys(columnData)) {
                if (key.startsWith('listing_column_type.')) {
                    return Boolean(flatData[key]?.exclude_from_search_default);
                }
            }
            return false;
        };

        // build relavent ColGroups
        let colGroups = Object.keys(rawCols)
            .map((colM1Key) => {
                for (let listingColumGroup of tierToListingColumnGroupMap) {
                    for (let [colGroupName, colObj] of Object.entries(listingColumGroup.columns)) {
                        if (colM1Key === colObj.m1Key) {
                            let filterData = [];
                            let trimmedFilterData = [];
                            if (colObj.filter) {
                                try {
                                    filterData = JSON.parse(colObj.filter);
                                    trimmedFilterData = filterData.map((filter) => {
                                        return filter.trimStart();
                                    });
                                } catch (err) {
                                    console.error("Failed parsing filterData", err);
                                }
                            }
                            return {
                                m1Key: colM1Key,
                                dataName: colObj.dataName,
                                order: listingColumGroup.order,
                                name: flatData[listingColumGroup.m1Key].display_name,
                                sort: colObj.sort,
                                sort_direction: colObj.sort_direction,
                                textAlign: colObj.text_align,
                                listingLogo: colObj.listing_logo,
                                width: colObj.width,
                                filter: trimmedFilterData,
                                headerAsLabel: colObj.header_as_label,
                                excludeFromSearch: Boolean(colObj.exclude_from_search) || columnTypeExcludesSearch(colM1Key),
                            };
                        }
                    }
                }

                return false;
            })
            .filter((obj) => {
                if (obj) {
                    return obj;
                }

                return false;
            })
            .map((col) => {
                return col;
            });

        // Mark detailsGrp items as hiddenAI if the column is both AI-populated and an additional search field
        const additionalSearchUUIDs = (tierConfig?.additionalSearchFields || []).map(u => u.replace('listing_column.', ''));
        detailsGrp.forEach((detail) => {
            const colUUID = detail.column_uuid.replace('listing_column.', '');
            const isAdditionalSearch = additionalSearchUUIDs.includes(colUUID);
            const isAIActive = flatData[detail.column_uuid]?.ai_generation_active || false;
            detail.hiddenAI = isAdditionalSearch && isAIActive;
        });

        return {
            settings: getComponentSettings(m1Key),
            rawCols,
            colGroups,
            detailsGrp,
            vals: [],
            listings,
            touchAction,
            tierConfig
        };
    }

    const getListingVals = function (k, listingGroup, obj, n = 0) {
        const colsKey = `${k}_${n}`;
        const cols = listingGroup.cols[colsKey] || [];
        // Cache messaging labels once per call
        const messagingLabels = extractMessagingLabels();

        const extractListingValue = (listingValue) => {
            let isJSON = false;
            let parsedValue;
            if (typeof listingValue === 'string' && listingValue.trim().startsWith('{')) {
                try {
                    parsedValue = JSON.parse(listingValue);
                    isJSON = true;
                } catch {}
            }
            if (isJSON) {
                if (parsedValue?.cc) {
                    const phoneData = parsedValue;
                    return messagingLabels.includes(phoneData.label)
                        ? `${phoneData.label}-${phoneData.area}-${phoneData.n}`
                        : `${phoneData.area}-${phoneData.n}`;
                }
                if (parsedValue?.email) {
                    const emailData = parsedValue;
                    return messagingLabels.includes(emailData.label)
                        ? `${emailData.label}-${emailData.email}@${emailData.domain}`
                        : `${emailData.email}@${emailData.domain}`;
                }
            }
            return listingValue === 'undefined' ? '' : listingValue || '';
        };

        const extractColumnData = (col, type = 'type') => {
            const columnData = flatData[col.m1Key];
            if (!columnData) return null;
            for (let m1Key in columnData) {
                if (m1Key.startsWith('listing_column_type.')) {
                    return type === 'type'
                        ? flatData[m1Key].type
                        : flatData[m1Key].display_name;
                }
            }
            return null;
        };

        obj.listings.forEach((listing) => {
            // Recursive call for nested listings
            if (listing.listings?.length > 0) {
                getListingVals(k, listingGroup, listing, n + 1);
            }

            listing.colGroups = [...cols];

            // Extract values, types, and display names in a single loop
            listing.vals = [];
            listing.types = [];
            listing.displayNames = [];
            cols.forEach((col) => {
                const rawValue = String(listing.rawCols[col.m1Key] || '');
                listing.vals.push(extractListingValue(rawValue));
                listing.types.push(extractColumnData(col, 'type'));
                listing.displayNames.push(extractColumnData(col, 'display_name'));
            });
        });
    }

    const getListingGroupCols = function (k, listingGroup, obj, n = 0) {
        let fullColumns = [],
            colsKey = `${k}_${n}`;

        for (let i = 0; i < obj.listings.length; i++) {
            for (let j = 0; j < obj.listings[i].listings.length; j++) {
                getListingGroupCols(k, listingGroup, obj.listings[i], n + 1);
            }

            if (fullColumns.length < obj.listings[i].colGroups.length) {
                fullColumns = [...obj.listings[i].colGroups];
            }
        }

        listingGroup.cols[colsKey] = fullColumns.sort((a, b) => {
            if (a.order > b.order) {
                return 1;
            }

            return -1;
        })
    }

    const getListingCollection = function (m1Key, columnGroups) {
        let m1Data = flatData[m1Key];
        m1Data.m1Key = m1Key;
        let listingConfigTierlist = listingCollectionToListingConfigTierMap[m1Key]

        let listingGroupToParentComponentMap = {};
        for (let [m1Key, m1Data] of Object.entries(flatData)) {
            if (m1Key.startsWith('component.')) {
                for (let m2Key of Object.keys(m1Data)) {
                    if (m2Key.startsWith('listing_group.')) {
                        listingGroupToParentComponentMap[m2Key] = m1Key;
                    }
                }
            }
        }

        let listingGroups = {};
        for (let [listingGroupM1Key, m1Data] of Object.entries(columnGroups)) {
            let listings = [];
            for (let m2Key of Object.keys(flatData[m1Key])) {
                if (m2Key.startsWith('listing.')) {
                    let listing = getListing(m2Key, m1Data, listingGroupM1Key, listingConfigTierlist);
                    if (!listing) {
                        continue;
                    }
                    listing.m1Key = m2Key;

                    listings.push(listing);
                }
            }

            let parentComponentM1Key = listingGroupToParentComponentMap[listingGroupM1Key];
            listingGroups[listingGroupM1Key] = {
                componentM1Key: parentComponentM1Key,
                settings: getComponentSettings(parentComponentM1Key),
                cols: {},
                listings,
            };
        }

        for (let [k, listingGroup] of Object.entries(listingGroups)) {
            getListingGroupCols(k, listingGroup, listingGroup);
        }
        for (let [k, listingGroup] of Object.entries(listingGroups)) {
            getListingVals(k, listingGroup, listingGroup);
            delete (listingGroups[k].cols);
        }

        return {
            m1Key,
            'listing_groups': listingGroups,
        };
    };

    const getListingGroupComponent = function (m1Key) {
        let m1Data = flatData[m1Key];

        let listingColumnGroups = [];
        for (let [m2Key, m2Data] of Object.entries(flatData[m1Key])) {
            if (m2Key.startsWith('listing_group.')) {
                for (let [key, columnGroup] of Object.entries(flatData[m2Key])) {
                    if (key.startsWith('listing_column_group.')) {
                        columnGroup.m1Key = key;
                        columnGroup.columns = {};

                        let col = {};
                        let displayName;
                        let dataName = '';
                        for (let [k, v] of Object.entries(flatData[key])) {
                            if (k === 'display_name') {
                                displayName = v;
                            }

                            if (k.startsWith('listing_column.')) {
                                col.m1Key = k;
                                for (let [_k, _v] of Object.entries(v)) {
                                    col[_k] = _v;
                                }
                            }
                            if (k.startsWith('listing_config.')) {
                                for (let [configKey, configValue] of Object.entries(flatData[k])) {
                                    if (configKey === 'display_name') {
                                        col.dataName = configValue;
                                    }
                                }
                            }

                        }
                        columnGroup.columns[displayName] = col;
                        listingColumnGroups.push(columnGroup);
                    }
                }
            }
        }

        return {
            settings: getComponentSettings(m1Key),
            'column_groups': listingColumnGroups,
        };
    };

    const getListingCollectionComponent = function (parentComponentM1Key) {
        let listingGroupComponents = {};
        for (let [m2Key, m2Data] of Object.entries(flatData[parentComponentM1Key])) {
            if (m2Key.startsWith('component.')) {
                let listingGroupComponent = getListingGroupComponent(m2Key);
                listingGroupComponents[m2Key] = listingGroupComponent;
            }
        }

        let columnGroups = {};
        for (let [m1Key, m1Data] of Object.entries(listingGroupComponents)) {
            for (let m2Key of Object.keys(flatData[m1Key])) {
                if (m2Key.startsWith('listing_group.')) {
                    columnGroups[m2Key] = m1Data.column_groups;
                }
            }
        }

        for (let [m2Key, m2Data] of Object.entries(flatData[parentComponentM1Key])) {
            if (m2Key.startsWith('listing_collection.')) {
                let listingCollection = getListingCollection(m2Key, columnGroups);
                listingCollection.settings = getComponentSettings(parentComponentM1Key);

                return listingCollection;
            }
        }
    }

    const {
        listingToTierMap,
        listingToParentListingsMap,
        listingToListingConfigMap,
        listingCollectionToListingConfigTierMap,
    } = makeMaps();

    let listingColumns = [];
    for (let m1Key of Object.keys(flatData)) {
        if (m1Key.startsWith('listing_column.')) {
            listingColumns.push(m1Key);
        }
    }

    let listingColumnToM1GroupMap = {};
    for (let [m1Key, m1Data] of Object.entries(flatData)) {
        if (m1Key.startsWith('listing_config.')) {
            for (let [m2Key, m2Data] of Object.entries(m1Data)) {
                if (m2Key.startsWith('listing_column.')) {
                    listingColumnToM1GroupMap[m2Key] = m2Data;
                    listingColumnToM1GroupMap[m2Key].m1Key = m2Key;
                    listingColumnToM1GroupMap[m2Key].name = m1Data['display_name'];
                }
            }
        }
    }
    for (let [m1Key, m1Data] of Object.entries(flatData)) {
        if (m1Key.startsWith('listing_column_group.')) {
            for (let [m2Key, m2Data] of Object.entries(m1Data)) {
                if (m2Key.startsWith('listing_column.')) {
                    listingColumnToM1GroupMap[m2Key] = m2Data;
                    listingColumnToM1GroupMap[m2Key].m1Key = m2Key;
                    listingColumnToM1GroupMap[m2Key].name = m1Data['display_name'];
                }
            }
        }
    }

    const typedComponents = getM2Data(flatData, 'component.', 'component_type.', {
        groupKey: 'type',
    });

    for (let [m1Key, m1Data] of Object.entries(flatData)) {
        if (m1Key.startsWith('component.')) {
            for (let m2Key of Object.keys(m1Data)) {
                if (m2Key.startsWith('listing_collection.')) {
                    listingCollectionComponentToListingCollectionMap[m1Key] = m2Key;
                }
            }
        }
    }

    const data = {};
    if (typeof typedComponents['listing_collection'] !== 'undefined') {
        Object.keys(typedComponents['listing_collection']).forEach((componentM1Key) => {
            let listingCollection = getListingCollectionComponent(componentM1Key);
            data[listingCollection.m1Key] = listingCollection;
        });
    }

    return data;
}

export default ListingETLNew;